import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';

interface AcceptSupplierChangesInput {
    supplierOrderId: string;
}

const acceptSupplierChanges = async (data: AcceptSupplierChangesInput, sessionId: string | null) => {
    return axios.post(`${API_URL}/order/supplier-changes/accept`, data, {
        headers: {
            Authorization: sessionId
        }
    });
};

export const useAcceptSupplierChanges = () => {
    const sessionContext = useContext(SessionContext);
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: AcceptSupplierChangesInput) => acceptSupplierChanges(data, sessionContext?.sessionId ?? null),
        onSuccess: () => {
            // Broad prefix match for open order views; order page also refreshes via refetch prop.
            queryClient.invalidateQueries({ queryKey: ['/order/detail'] });
            queryClient.invalidateQueries({ queryKey: ['/order/activity-logs'] });
            queryClient.invalidateQueries({ queryKey: ['/order/drawer'] });
            queryClient.invalidateQueries({ queryKey: ['order-confirmation'] });
            queryClient.invalidateQueries({ queryKey: ['quoteData'] });
        },
        onError: (error) => {
            console.error('Failed to accept supplier changes:', error);
        }
    });
};
